import { styled } from 'styled-components';

export const PositionChipWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.sizing.small};
  margin: ${({ theme }) => theme.sizing.tiny} 0 0 0;
`;
PositionChipWrapper.displayName = 'PositionChipWrapper';

export const PositionModalBigWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.sizing.medium};

  label {
    width: 100%;
  }
`;
PositionModalBigWrapper.displayName = 'PositionModalBigWrapper';

export const PositionModalContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};
  width: auto;
  flex-direction: ${({ $asColumn }) => ($asColumn ? 'column' : 'row')};
`;
PositionModalContent.displayName = 'PositionModalContent';

export const PositionCategory = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.small};
`;
PositionCategory.displayName = 'PositionCategory';

export const PositionGroup = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.sizing.small};
  grid-template-columns: repeat(${({ $wider }) => ($wider ? '3' : '2')}, 1fr);

  @media (min-width: 1165px) {
    grid-template-columns: repeat(${({ $wider }) => ($wider ? '4' : '2')}, 1fr);
  }

  @media (min-width: 1370px) {
    grid-template-columns: repeat(${({ $wider }) => ($wider ? '4' : '3')}, 1fr);
  }

  @media (min-width: 1465px) {
    grid-template-columns: repeat(${({ $wider }) => ($wider ? '5' : '3')}, 1fr);
  }
`;
PositionGroup.displayName = 'PositionGroup';

export const PositionModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .buttons {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
`;
PositionModalHeader.displayName = 'PositionModalHeader';
